.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
}

/* Stretched-link row: the link's ::after covers the row, so the whole row is the target. */
.row {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-1_5);
  border-radius: var(--tuna-shape-radius-md);
}

.row:hover {
  background: var(--tuna-palette-action-hover);
}

.row:has(.link:focus-visible) {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: 2px;
}

.link {
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body2-fontSize);
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
}

.link:focus-visible {
  outline: none;
}

.meta {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-caption-fontSize);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
